



























import { genPneuComputeds } from './pneuHelpers';

export default {
	name: 'Rozmery',
	props: {
		storeUri: { type: String, default: null, required: true },
		index: { type: Number, required: true },
		disabled: { type: Boolean },
		required: Boolean,
	},
	computed: {
		...genPneuComputeds(),
	},
};
